import React, { FunctionComponent } from "react";

import { DetailedCartItem } from "../../../../../../../../context/CartContext/CartContext.api.types";
// Components
import MainDetail from "./MainDetail";
// Styles
import "./CartDetailedItemDesktop.scss";

type Props = {
  cartDetailedItem: DetailedCartItem;
  onDelete: () => void;
  onEdit: (cartDetailedItem: DetailedCartItem) => void;
  labels: LenghtLabel;
};

const CartDetailedItemComponentDesktop: FunctionComponent<Props> = ({
  cartDetailedItem,
  onDelete,
  onEdit,
  labels,
}) => (
  <div className="cart-detailed-item-desktop">
    <MainDetail
      cartDetailedItem={cartDetailedItem}
      onDelete={onDelete}
      onEdit={onEdit}
      labels={labels}
    />
  </div>
);

export default CartDetailedItemComponentDesktop;
